<template>
  <transition name="q-zoom-in-center">
    <span
      :class="classes"
      :style="'backgroundColor: '+ color"
      @click="handleClick"
    >
      <slot />
      <i
        v-show="closable"
        class="q-tag__close q-icon-close"
        :style="isRtl ? 'left: -3px;' : 'right: -3px;'"
        @click="handleClose"
      />
    </span>
  </transition>
</template>

<script>
  export default {
    name: 'QTag',
    componentName: 'QTag',
    props: {
      text: String,
      closable: Boolean,
      type: String,
      hit: Boolean,
      disableTransitions: Boolean,
      color: String,
      size: String,
      effect: {
        type: String,
        default: 'light',
        validator(val) {
          return ['dark', 'light', 'plain'].indexOf(val) !== -1;
        }
      }
    },
    computed: {
      isRtl() {
        return this.$qt('direction') === 'rtl';
      },
      tagSize() {
        return this.size || (this.$ELEMENT || {}).size;
      },
      classes() {
        const {type, tagSize, hit, effect} = this;
        return [
          'q-tag',
          type ? `q-tag--${type}` : '',
          tagSize ? `q-tag--${tagSize}` : '',
          effect ? `q-tag--${effect}` : '',
          hit && 'is-hit'
        ];
      }
    },
    methods: {
      handleClose(event) {
        event.stopPropagation();
        this.$emit('close', event);
      },
      handleClick(event) {
        this.$emit('click', event);
      }
    },
  };
</script>
